import { render, staticRenderFns } from "./search-card.vue?vue&type=template&id=06e62e57&scoped=true"
import script from "./search-card.vue?vue&type=script&lang=js"
export * from "./search-card.vue?vue&type=script&lang=js"
import style0 from "./search-card.vue?vue&type=style&index=0&id=06e62e57&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e62e57",
  null
  
)

export default component.exports